import { GeneralPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const inventorySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "General", permission: GeneralPermissions.OTHER },
    path: "inventory-management/general",
    lazy: async () => {
      const { InventoryManagementGeneralSettingsPage } =
        await import("../../../../setting/inventory-management/general-settings");
      return { Component: InventoryManagementGeneralSettingsPage };
    },
  },
  {
    handle: {
      breadcrumb: "Purchase orders",
      permission: GeneralPermissions.OTHER,
    },
    path: "inventory-management/purchase-orders",
    lazy: async () => {
      const { PurchaseOrderSettingsPage } =
        await import("../../../../setting/inventory-management/purchase-order-settings");
      return { Component: PurchaseOrderSettingsPage };
    },
  },
  {
    handle: {
      breadcrumb: "QuickBooks Online",
      permission: GeneralPermissions.OTHER,
    },
    path: "inventory-management/quickbooks",
    children: [
      {
        index: true,
        lazy: async () => {
          const { QuickBooksIntegrationSettingsPage } =
            await import("../../../../setting/inventory-management/quickbooks-integration-settings");
          return { Component: QuickBooksIntegrationSettingsPage };
        },
      },
      {
        handle: {
          breadcrumb: "QuickBooks account mappings",
          permission: GeneralPermissions.OTHER,
        },
        path: "account-mapping",
        lazy: async () => {
          const { QuickBooksAccountMappingPage } =
            await import("../../../../setting/inventory-management/quickbooks-account-mapping");
          return { Component: QuickBooksAccountMappingPage };
        },
      },
    ],
  },
];
